import { useTranslation } from 'react-i18next';
import { Card } from '@/common/components/Card/Card';
import { Grid } from '@/common/components/Grid/Grid';
import { Label } from '@/common/components/Label/Label';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { MARKET } from '@/common/constants/markets';
import { useMarket } from '@/common/hooks/useMarket';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { DateUtils } from '@/common/utils/date';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

export function PolicySummaryCard({ policy }: TPolicySummaryCardProps) {
  const { t } = useTranslation();
  const { slug } = useMarket();

  return (
    <Card plain>
      <Grid columnBasis="basis-[14rem]" gap="md">
        <LabeledValue
          label={t('dashboard.insurance_detail.table_headers.paid_by_you')}
          value={
            <Label size="xl" bold>
              {MoneyUtils.formatMoney(policy.totalCost?.paidByEmployee)}
            </Label>
          }
        />
        {slug === MARKET.ES && (
          <LabeledValue
            label={t('dashboard.insurance_detail.table_headers.next_payment')}
            value={DateUtils.formatDate(policy.metadata?.nextPaymentOn)}
          />
        )}
        <LabeledValue
          label={t('dashboard.insurance_detail.table_headers.paid_by_company')}
          value={MoneyUtils.formatMoney(policy.totalCost?.paidByCompany)}
        />
        <LabeledValue
          label={t('dashboard.insurance_detail.table_total_cost')}
          value={MoneyUtils.formatMoney(policy.totalCost?.premium)}
        />
      </Grid>
    </Card>
  );
}

export type TPolicySummaryCardProps = {
  policy: IInsurancePolicy;
};
